module.exports = __webpack_public_path__ + "static/media/PF_Staking-Multipliers.b286bd02.jpg";